module.exports = __webpack_public_path__ + "img/remy-and-rose_banner.2e089093.jpg";